import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const Conversations = lazy(() => import('../../container/conversation/Conversations'));
const Request = lazy(() => import('../../container/conversation/RequestTextTable'));
const WhatsAppMessageDetails = lazy(() => import('../../container/conversation/overview/WhatsAppMessageDetails'));
const ConversationOverview = lazy(() => import('../../container/conversation/overview/ConversationOverview'));
const SinglePostView = lazy(() => import('../../container/conversation/overview/SinglePostView'));
const TelephonyMessageSummery = lazy(() => import('../../container/conversation/overview/TelephonyMessageSummery'));

function ConversationRoutes() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/log`} component={Conversations} />
      <Route path={`${path}/request`} component={Request} />
      <Route path={`${path}/summery/:id`} component={ConversationOverview} />
      <Route path={`${path}/whatsapp/message/details/:conversationId`} component={WhatsAppMessageDetails} />
      <Route path={`${path}/telephony/message/v1/details/:_id`} component={TelephonyMessageSummery} />
      <Route path={`${path}/posts/view/v1/:id`} component={SinglePostView} />
    </Switch>
  );
}

export default ConversationRoutes;
